import { Client } from 'irc-framework';
import { IRC_EVENT, IRCMessageType } from '#/types/types';
import ConnectionHandler from '#/connectionHandler';
import TabManager from '#/ui/tabManager';
import MessageHandler from '#/messageHandler';

export class ConnectionEventListener {
    private cH: ConnectionHandler;
    private client: Client;
    private tM: TabManager;
    private mH: MessageHandler;

    constructor(connectionHandler: ConnectionHandler) {
        this.cH = connectionHandler as ConnectionHandler;
        this.client = connectionHandler.client as Client;
        this.tM = connectionHandler.tabManager as TabManager;
        this.mH = connectionHandler.messageHandler as MessageHandler;
        this.setup();
    }

    private setup(): void {
        this.client.on(IRC_EVENT.CONNECTED, () => {
            this.cH._isConnected = true;
            this.cH.reconnectAttempts = 0;
            this.cH.updateButtonStates();
            this.mH.addMessage(this.tM.getStatusTab(), 'Connected to IRC server via WebSocket', IRCMessageType.SYSTEM);
            if (this.cH.autoJoinChannels.length > 0) {
                this.mH.addMessage(this.tM.getStatusTab(), `Auto-joining channels: ${this.cH.autoJoinChannels.join(', ')}`, IRCMessageType.SYSTEM);
                this.cH.autoJoinChannels.forEach((channel: string) => {
                    const success = this.cH.joinChannel(channel);
                    if (!success) {
                        this.mH.addMessage(this.tM.getStatusTab(), `Failed to join ${channel}`, IRCMessageType.ERROR);
                    }
                });
            }
            if (this.cH.ircClient.settings.nickservPassword) {
                this.cH.sendRaw(`NS IDENTIFY ${this.cH.ircClient.settings.nickservPassword}`);
            }
        });

        this.client.on(IRC_EVENT.DISCONNECTED, () => {
            this.cH._isConnected = false;
            this.cH.updateButtonStates();
            this.mH.addMessage(this.tM.getStatusTab(), 'Disconnected from server', IRCMessageType.SYSTEM);
        });

        this.client.on(IRC_EVENT.REGISTERED, () => {
            this.mH.addMessage(this.tM.getStatusTab(), 'Successfully registered with IRC server', IRCMessageType.SYSTEM);
        });
    }
}